// Entry point for the build script in your package.json

// TODO: do usunięcia (blokuje:
//   - remote: true na liście BS(views/bib_schemas/_reindex_button.html.slim)
//     do przepisania przez GB na turbo stream'y, usunięcie JobsChannel + JS channels/jobs_channel.js,
//   - @hotwired/turbo przejeło funkcjonalność potwierdzania ale brakuje eventu
//     "confirm:complete" wykorzystywanego do potwierdzania usuwania w zagniezdzonych formularzach
// )
import Rails from "@rails/ujs"
Rails.start()

// UWAGA: nie importować Turbo, korzystać z `window.Turbo`
import "@hotwired/turbo-rails"

import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()

// TODO: do usunięcia (blokuje select2 użyty w:
//   przycisk "Dodaj" (Grupa wartości indeksu - edycja - Wartości indeksów),
//   przycisk "Dodaj" (Katalog schematu bibliograficznego - edycja - Schematy bibliograficzne),
//   "Wartość indeksu" (Kolekcja specjalna - edycja),
//   "ID rekordów wejściowych" i "ID rekordów wyjściowych" (Scalenie - tworzenie),
//   "ID przypisanych rekordów bibliograficznych" (Rekord OAI-PMH - edycja),
//   "Rekordy OAI-PMH ID" i "ID rekordów bibliograficznych" (Rekordy OAI-PMH / Przypisz rekordy bibliograficzne),
//   "Dodaj pole" / "Dodaj podpole" (Definicja indeksów - edycja, Maska - edycja, edycja MARC),
//   filtr "ID w" (filters--id_in, Rekordy OAI-PMH),
//   filtr "Kod egzemplarza w" (RE, Zamówienia RE),
//   filtr "Przypisana do ID w" (Uwagi),
//   filtr "Status w" (Rekordy OAI-PMH),
//   filtr "Rekord bibliograficzny ID w"(Rekordy OAI-PMH),
//   filtr "ID rekordów OAI-PMH w" (Importy OAI-PMH)
// )
import "jquery"

// TODO: are_you_sure_form.coffee.erb do przepisania od nowa
import "./vendor"

import "chartkick/chart.js" // 600kB TODO: ładować tylko na stronie statystyk

import "./controllers"
